export default __webpack_public_path__ + "static/media/JIN_logo.ec51ab2a.svg";